import { FC } from 'react';

import css from './MetadataDetailsList.module.scss';

interface MetadataDetailsListProps {
  details: string[];
}

export const MetadataDetailsList: FC<MetadataDetailsListProps> = ({
  details,
}) => (
  <ul className={css.metadataDetailsList}>
    {details.map((detail, index) => (
      <li key={detail + index}>{detail}</li>
    ))}
  </ul>
);
